import { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { isMuted, playThunder, setMuted, unlockAudio } from "../../lib/thunder";

export const SoundToggle = () => {
  const [muted, setM] = useState(isMuted);
  useEffect(() => {
    const sync = () => setM(isMuted());
    const unlock = () => unlockAudio();
    window.addEventListener("asap-sound", sync);
    window.addEventListener("pointerdown", unlock, { once: true });
    return () => {
      window.removeEventListener("asap-sound", sync);
      window.removeEventListener("pointerdown", unlock);
    };
  }, []);

  const toggle = (e) => {
    e.stopPropagation();
    const next = !muted;
    setMuted(next);
    if (!next) playThunder();
  };

  return (
    <button onClick={toggle} aria-label={muted ? "Turn sound on" : "Mute sound"} title={muted ? "Sound off" : "Sound on"}
      className="fixed bottom-4 left-4 z-[110] grid h-11 w-11 place-items-center rounded-full border border-white/15 bg-black/70 text-white backdrop-blur transition-transform duration-200 hover:scale-110 hover:border-[#E5202A]"
      data-testid="sound-toggle-button" data-muted={muted ? "true" : "false"}>
      {muted ? <VolumeX className="h-5 w-5 text-slate-400" /> : <Volume2 className="h-5 w-5 text-[#E5202A]" />}
    </button>
  );
};
